import Layout from '../components/layout'
import dynamic from 'next/dynamic';
import React, {useEffect} from "react"
import Image from 'next/image'
import {useRouter} from "next/router";
import {
    preClick,
    postView,
    hasRedtrackData,
    getPreJs,
    preInit,
    preView,
    redtrackSubmitInit
} from "../utils/redtrack";

const RegistrationForm = dynamic(() => import('../components/pages/registration/form'));

function Register() {

    useEffect(() => {
        redtrackSubmitInit();
    }, []);


    const registrationView = <div className="main-contact-container">

        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <div className="cont-detail">

                        <Image src="/images/mini-logo.svg" width="150" height="50"
                               alt="Irs-Extension.Online logo"/>

                        <hr/>
                        <h5>Enter your details below to get started</h5>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <div className="forgotpass">
                        <RegistrationForm/>
                    </div>
                </div>
            </div>
        </div>


    </div>
    return (
        <Layout preHeader={registrationView}>

        </Layout>
    )
}


export default Register;
